import { registerLocaleData } from '@angular/common';
import { Component } from '@angular/core';
import localeIt from '@angular/common/locales/it';
import { LayoutService } from './shared/services/layout.service';
import { AccountService } from './views/sessions/services/account.services';


@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  
  constructor(private layoutConf: LayoutService, private accountService: AccountService,) {
    this.layoutConf.init();
  }
  
  ngOnInit(){
    registerLocaleData(localeIt, 'it-IT');
  }

}
